import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const CasualtyRespone = () => {
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} onLoad={() => window.scrollTo(0, 0)}>
                <div className="col-12">
                    <Header actives="CasualtyRespone" />
                    <HerosectionsAll ScreenName="Casualty Response" ScreenSearch="CasualtyRespone" />

                    <div className="row col-lg-11 mx-auto p-2 p-lg-5 my-5">
                      


                        <div className="col-12 p-lg-5 p-4 faint " style={{ textAlign: 'justify',}}>
                            <h5 className="fw-bold pb-3 gray_color">Casualty Response</h5>
                            <ul className="ps-4">
                                <li>
                                 We became part of the Client’s Emergency/Casualty Response Team to provide expert advice on the technical, commercial, contractual, and legal aspects to determine options for loss mitigation. Conduct risk assessments of the proposed mitigation measures to ensure Client’s due diligence. Proactively analyse the impact on various contracts (including insurance) and compliance issues to ensure no breaches of contractual provisions and statutory stipulations.
                                </li>
                            </ul>
                        </div>


                    </div>

                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
